export default __webpack_public_path__ + "static/mini-helix-ps-3-178d4acbc9efdfe768522ed0711e2c76.jpg";